import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { startGetOrdenPagoV2 } from '../context/actions/pagos2Actions';

export const useReloadAfterAction = (ordenPagoID) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const executeWithReload = async (actionFn, onSuccess) => {
    setLoading(true);
    try {
      const result = await actionFn();

      if (result?.success !== false) {
        await dispatch(startGetOrdenPagoV2(ordenPagoID));
        if (onSuccess) onSuccess(result);
      }

      return result;
    } finally {
      setLoading(false);
    }
  };

  return { loading, executeWithReload };
};